import { FC, useState } from "react";
import { Link } from "react-router-dom";
import { Navbar, NavbarBrand, Collapse, NavbarToggler, Nav, NavItem } from "reactstrap";
import { RootState } from "store/types";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { deleteSession } from "store/actions/session";
import Icon from 'components/icon';
import { UserData } from "store/reducers/session/types";

import './header.scss';

interface StateProps {
  isAuthenticated: boolean;
  user: UserData | null;
};

interface DispatchProps {
	deleteSession: () => void;
};

interface OwnProps {};
interface AppHeaderProps extends DispatchProps, StateProps, OwnProps {};

const AppHeader: FC<AppHeaderProps> = ({ isAuthenticated, user, deleteSession }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggle = (): void => setIsOpen(!isOpen);
  const logOut = (): void => deleteSession();

  return (
    <Navbar className="navbar-header px-0" dark expand="md">
      <div className="container-fluid">
        <NavbarBrand to="/" tag={Link}>
          <Icon name="sasr" />
        </NavbarBrand>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="ml-auto align-items-center" navbar>
            {(isAuthenticated && user) && <>
              <NavItem>
                <span className="navbar-username">
                  {user.firstName} {user.lastName}
                </span>
              </NavItem>
              <NavItem>
                <button className="btn-logout" onClick={logOut}>
                  <Icon title="Log Out" name="logout" />
                </button>
              </NavItem>
            </>}
          </Nav>
        </Collapse>
      </div>
    </Navbar>
  );
};

const mapStateToProps = (state: RootState): StateProps => ({
  isAuthenticated: state.session.isAuthenticated,
  user: state.session.user
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  deleteSession: () => dispatch(deleteSession())
});

export default connect<StateProps, DispatchProps, OwnProps, RootState>(
	mapStateToProps,
	mapDispatchToProps
)(AppHeader);